<script>
import {
  defineComponent,
  inject,
  computed,
  watchEffect,
  ref,
  watch,
  nextTick,
} from "vue";
import NavMainSearch from "@kit/components/NavMainSearch.vue";
import { searchWidgetMain, navbar } from "@project/themes";
import NavBarBase from "@kit/components/NavBarBase.vue";
import IconButton from "@kit/components/IconButton.vue";
import Icon from "@kit/components/Icon.vue";
import { inBrowser } from "@kit/utils/EnvironmentHelper";
import { cmsasset } from "@kit/utils/Formats";
import { useStore } from "vuex";
import "@css/index.css";

export default defineComponent({
  name: "NavBar",
  setup() {
    const store = useStore();
    const navbarTheme = navbar
    const searchWidgetMainTheme = searchWidgetMain
    const atTop = ref(true);

    // const okToShow = computed(() => {
    //   return route.name != "contact-us" && route.name != "gtfsrt";
    // });

    // const inMobile = computed(() => {
    //   return store.state.inMobile;
    // });

    const topOn = () => {
      atTop.value = true;
    };
    const topOff = () => {
      atTop.value = false;
    };

    return {
      atTop,
      searchWidgetMainTheme,
      navbarTheme,
      cmsasset,
      topOn,
      topOff,
    };
  },
  components: {
    NavMainSearch,
    NavBarBase,
    IconButton,
    Icon,
  },
});
</script>

<template>
  <NavBarBase @TopOn="topOn" @TopOff="topOff" :theme="navbarTheme">
    <template v-slot:top-area>
      <div class="sb sb-h sb-content-space-between">
        <div class="sb sb-v">
          <h1 class="sb sb-text">Fort Bidwell Paiute Reservation</h1>
          <h2 class="sb sb-text">Gidutikad Band</h2>
        </div>
        <div class="sb sb-v" style="padding-right:20px;">
          <a class="sb sb-text portal-link" href="https://fbcommunityportal.powerappsportals.com">Fort Bidwell Member Portal</a>
        </div>
      </div>
    </template>

    <template
      v-slot:nav-area="{ navItemClasses, dropDownNavItemClasses, navSubItemClasses }"
    >

      <div class="sb sb-h sb-greedy-1">

        <div :class="`fbicc-nav-wrapper sb sb-h sb-greedy ${ atTop ? 'sb-content-space-between' : 'sb-align-2right'}`">

          <div :class="dropDownNavItemClasses">
            About &amp; News
            <div
              :class="`${navSubItemClasses} fbicc-top-nav-routes-subitems`"
              aria-description="This is a menu showing general information and news."
              aria-role="menu"
              aria-orientation="vertical"
            >
            
                <router-link
                  class="sb fbicc-navbar-dropdown-option"
                  to="/our-history">
                  Our History
                </router-link>
                <router-link
                  class="sb fbicc-navbar-dropdown-option"
                  to="/calendar">
                  Calendar
                </router-link>
                <router-link
                  class="sb fbicc-navbar-dropdown-option"
                  to="/news">
                  News
                </router-link>

            </div>
          </div>


          <div :class="dropDownNavItemClasses">
            Gov't &amp; Facilities
            <div
              :class="`${navSubItemClasses} fbicc-top-nav-routes-subitems`"
              aria-description="This is a menu showing gov't services and local facilities."
              aria-role="menu"
              aria-orientation="vertical"
            >
            
                <!-- <router-link
                  class="sb fbicc-navbar-dropdown-option"
                  to="/government">
                  Government
                </router-link> -->
                <router-link
                  class="sb fbicc-navbar-dropdown-option"
                  to="/government/forms">
                  Forms
                </router-link>
                <router-link
                  class="sb fbicc-navbar-dropdown-option"
                  to="/housing">
                  Housing
                </router-link>
                <router-link 
                  class="sb fbicc-navbar-dropdown-option"
                  to="/wellness-center">
                  Wellness Center
                </router-link>
      
            </div>
          </div>

          <router-link to="/staff" :class="navItemClasses">Staff</router-link>

          <router-link to="/careers" :class="navItemClasses">Careers</router-link>

          <router-link to="/contact-us" :class="navItemClasses">Contact</router-link>

        </div>
        <div class="sb sb-explicit" style="width:70px;">
          <NavMainSearch :theme="searchWidgetMainTheme" />
        </div>
      </div>

   
      <!--
      <div :class="dropDownNavItemClasses">
        Routes and Services
        <div
          :class="`${navSubItemClasses} fbicc-top-nav-routes-subitems`"
          aria-description="This is a menu showing the available services from HTA."
          aria-role="menu"
          aria-orientation="vertical"
        >
          <template v-if="serviceAgencies.length > 0">
            <router-link
              v-for="serviceAgency in serviceAgencies"
              class="sb fbicc-navbar-dropdown-option"
              :to="
                serviceAgency.url
                  ? serviceAgency.url
                  : `/agencies/${serviceAgency.url_slug}`
              "
              :style="`color:${serviceAgency.final_text_color}; background-color:${serviceAgency.final_color};`"
            >
              {{ serviceAgency.display_name }}
            </router-link>
          </template>
        </div>
      </div>
      -->

    </template>
  </NavBarBase>

</template>
